/**
 * Local analytics / third-party telemetry consent (e.g. Sentry).
 * Explicit banner choice is stored in localStorage; account-level flags can also allow Sentry
 * when the user has not chosen "essential only" on this device.
 */
const STORAGE_KEY = 'mypace_analytics_consent_v1';
export function getAnalyticsConsentExplicit() {
    if (typeof window === 'undefined')
        return null;
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === '1')
        return true;
    if (v === '0')
        return false;
    return null;
}
/** Persist opt-in (1) or opt-out (0) from the cookie banner. */
export function setAnalyticsConsentExplicit(granted) {
    localStorage.setItem(STORAGE_KEY, granted ? '1' : '0');
    window.dispatchEvent(new CustomEvent('mypace:analytics-consent-changed'));
}
/** Sentry / crash reporting: default off until banner accept or account consent flags. */
export function shouldEnableSentry(user) {
    const explicit = getAnalyticsConsentExplicit();
    if (explicit === false)
        return false;
    if (explicit === true)
        return true;
    return !!(user?.data_processing_consent || user?.learning_analytics_consent);
}
export function shouldShowCookieBanner(user) {
    if (getAnalyticsConsentExplicit() !== null)
        return false;
    if (user?.data_processing_consent || user?.learning_analytics_consent)
        return false;
    return true;
}
